import { Clock, MapPin, MessageCircle, Phone, ArrowUpRight } from "lucide-react";
import { SITE } from "@/config/site";
import { PageHeader } from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Motion";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";

const INFO = [
  { id: "indirizzo", icon: MapPin, label: "Indirizzo", lines: [SITE.address] },
  { id: "telefono", icon: Phone, label: "Telefono fisso", lines: [SITE.phoneDisplay], href: SITE.phoneHref },
  { id: "cellulare", icon: MessageCircle, label: "Cellulare · WhatsApp", lines: [SITE.mobileDisplay], href: SITE.mobileHref },
  { id: "orari", icon: Clock, label: "Apertura", lines: SITE.hours },
];

const InfoCard = ({ icon: Icon, label, lines, href, id }) => {
  const body = (
    <>
      <Icon className="w-7 h-7 text-[#FF5500] transition-transform duration-500 group-hover:-rotate-12" />
      <p className="mt-8 eyebrow">{label}</p>
      {lines.map((l) => <p key={l} className="mt-2 font-semibold text-lg leading-snug">{l}</p>)}
    </>
  );
  const cls = "group block h-full rounded-[1.75rem] border border-white/10 bg-[#16161A] p-7 transition-colors duration-500 hover:border-[#FF5500]/60";
  return href ? (
    <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={`contact-card-${id}`} className={cls}>{body}</a>
  ) : (
    <div data-testid={`contact-card-${id}`} className={cls}>{body}</div>
  );
};

export default function Contatti() {
  return (
    <div data-testid="contatti-page">
      <PageHeader testid="contatti-header" eyebrow="Contatti" lines={[{ text: "Passa" }, { text: "a trovarci.", className: "text-[#FF5500]" }]} text="Prenota il tuo pollo: chiamaci allo 081 18330419 o al 335 282535, oppure scrivici su WhatsApp." />
      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-28">
        <Reveal className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <a href={SITE.phoneHref} data-testid="contatti-call-button" className="group flex items-center justify-between rounded-[2rem] bg-[#FF5500] text-[#0D0D0F] px-7 py-7 sm:px-10 sm:py-9 transition-transform duration-500 hover:-translate-y-1">
            <span className="flex items-center gap-4 font-display uppercase text-2xl sm:text-3xl xl:text-4xl tracking-[-0.02em]"><Phone className="w-8 h-8" strokeWidth={2.4} /> Chiama</span>
            <ArrowUpRight className="w-9 h-9 transition-transform duration-500 group-hover:rotate-45" />
          </a>
          <a href={SITE.whatsappHref} target="_blank" rel="noreferrer" data-testid="contatti-whatsapp-button" className="group relative flex items-center justify-center rounded-[2rem] bg-[#25D366] text-[#0D0D0F] px-7 py-7 sm:px-10 sm:py-9 transition-[transform,background-color] duration-500 hover:-translate-y-1 hover:bg-[#2BE070]">
            <span className="flex items-center gap-4 font-display uppercase text-2xl sm:text-3xl xl:text-4xl tracking-[-0.02em]"><WhatsAppIcon className="w-8 h-8 sm:w-9 sm:h-9" /> WhatsApp</span>
          </a>
        </Reveal>
        <div className="mt-3 grid gap-3 lg:grid-cols-12">
          <div className="lg:col-span-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
            {INFO.map((c, i) => (
              <Reveal key={c.id} delay={i * 0.06}><InfoCard {...c} /></Reveal>
            ))}
          </div>
          <Reveal className="lg:col-span-7" delay={0.1}>
            <div data-testid="contatti-map" className="relative h-[380px] lg:h-full min-h-[380px] overflow-hidden rounded-[2rem] border border-white/10">
              <iframe title="Mappa Mister Pollo Volla" src={SITE.mapSrc} className="absolute inset-0 w-full h-full map-dark" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
